import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Layout/Header';
import Home from './pages/Home';
import SectionLayout from './Layout/SectionLayout';
import PrivacyHub from "./pages/privacy/PrivacyHub";
import PrivacyFmcAurora from "./pages/privacy/PrivacyFmcAurora";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about/*" element={<SectionLayout section="about" />} />
        <Route path="/services/*" element={<SectionLayout section="services" />} />
        <Route path="/privacy" element={<PrivacyHub />} />
        <Route path="/privacy/fmc-aurora" element={<PrivacyFmcAurora />} />
      </Routes>
    </Router>
  );
}

export default App;
